module.exports = __webpack_public_path__ + "fonts/AudiType-Italic_4.03.4d7a9ef3.woff2";